import { getNestedList } from "globals/helpers/helpers"
import { FilterGroup } from "./filters.era"
import { Program } from "globals/store/programs.data"
import { Exhibitor, ProgramsExhibitors } from "globals/store/exhibitors.data"
import { JoiEvent } from "./events.era"
import { getProgramIdsByExhibitorIds } from "globals/helpers/program.helper"


export const filterExhibitors = (filters: FilterGroup, programs: { [pId:string]: Program }, exhibitorList: Exhibitor[], event: JoiEvent): ProgramsExhibitors => {
  if (!event) return null
  const programIds: Set<string> = new Set()
  const programIdsByExhibitorIds = getProgramIdsByExhibitorIds(event.exhibitorStands)
  exhibitorList = exhibitorList.filter(e => {
    const ePrograms = (programIdsByExhibitorIds[e.id] || []).map(id => programs[id]).filter(p => p)
    ePrograms.forEach(({ id }) => programIds.add(id))
    const eProgramLabels = getNestedList(ePrograms, 'labels')
    return ![
      () => !filters.programs || ePrograms.some(p => filters.programs.includes(p.id)),
      () => !filters.programLabels || eProgramLabels.some(l => filters.programLabels.includes(l)),
      () => !filters.exhibitorLabels || (e.labels && e.labels.some(l => filters.exhibitorLabels.includes(l))),
      () => !filters.tags || (e.workforceContactEmail && filters.tags.includes(e.workforceContactEmail)),
      () => !filters.types || (filters.types.includes(e.entityTypeId))
    ].some(passesFilterFunction => !passesFilterFunction())
  })
  const programList = Object.values(programs).filter(p => programIds.has(p.id))
  return { exhibitorList, programList }
}